import React from "react"
import ReactDOM from "react-dom/client"
import "./styles/styles"
import reportWebVitals from "./reportWebVitals"

import App from "./App"
import "primeflex/primeflex.css"
import "primeicons/primeicons.css"
import "primereact/resources/themes/saga-blue/theme.css"
const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
